import { Component, inject } from "@angular/core";
import { ToastrService } from "../../services/toastr.service";

@Component({
  selector: "app-toastr",
  templateUrl: "./toastr.html",
  styleUrl: "./toastr.scss"
})
export class Toastr {
  protected readonly toastr = inject(ToastrService);
}
